import type { EntitlementDetails } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import { useTenantContext } from '../tenant-context/index.tsx';

export const useProductEntitlementDetails = (): Record<string, EntitlementDetails> | null => {
	const tenantContext = useTenantContext();
	return (tenantContext && tenantContext.productEntitlementDetails) || null;
};
